// extracted by mini-css-extract-plugin
export default {"report_heading":"dailyReport_report_heading__CS1AT","back__icon":"dailyReport_back__icon__HFiVD"};